import React from 'react'
import { useDispatch } from 'react-redux'
import moment from 'moment-timezone'
import CloseIcon from 'transfix-icons/build/CloseIcon'
import { IconButton } from 'transfix-ui/components/IconButton'
import { deleteDocUpload } from 'utils/actions/carrier'
import { FORMATS } from 'constants/datetime'

interface IAddedDocumentsProps {
  document?: {
    id: string
    fileFileName?: string
    file?: string
    createdAt?: string
  }
}

export const AddedDocuments: React.FunctionComponent<IAddedDocumentsProps> = React.memo(
  ({ document }) => {
    const dispatch = useDispatch()
    const onDelete = () => document?.id && dispatch(deleteDocUpload(document.id))

    return (
      <div className='mb1'>
        {document?.fileFileName && (
          <span key={document.fileFileName}>
            <span className='btn-text-link'>{document.fileFileName}</span>
            <IconButton
              label='close'
              onClick={onDelete}
              Icon={CloseIcon}
              data-test='single-doc'
              className='xlarge fr'
              size='large'
            />
            <p className='text-secondary'>
              {moment(document.createdAt).format(FORMATS.dateFormat)}
            </p>
            <hr />
          </span>
        )}
      </div>
    )
  }
)
